// Copyright © 2019-2026 Focal Systems. All rights reserved.

// AAGUID → authenticator/provider name. AAGUIDs are public, well-known model identifiers (not
// secrets), so this lookup runs client-side. Sourced from the community catalog
// passkeydeveloper/passkey-authenticator-aaguids (names only — icons stripped to keep it small).
// Regenerate by fetching combined_aaguid.json and mapping each entry to its `name`.
//
// Note: many synced passkeys report an all-zero AAGUID and won't be found here — that's expected.
export const AAGUID_NAMES: Record<string, string> = {
  "005b20e1-f146-4b87-8f3a-36848ff60ea6": "SECORA ID V2 by Infineon Pay Edition M",
  "0076631b-d4a0-427f-5773-0ec71c9e0279": "HYPR FIDO2 Authenticator",
  "019614a3-2703-7e35-a453-285fd06c5d24": "ATLKey Authenticator",
  "03012cb7-4fb2-42e7-9e8d-a81f10e2a5e9": "YubiKey 5 Series with Lightning (Consumer Profile)",
  "04a8fcf2-19c1-457b-911e-69219f17583f": "Thales PAY GFCX13 authenticator",
  "050dd0bc-ff20-4265-8d5d-305c4b215192": "eToken Fusion FIPS",
  "07a9f89c-6407-4594-9d56-621d5f1e358b": "NXP Semiconductros FIDO2 Conformance Testing CTAP2 Authenticator",
  "08987058-cadc-4b81-b6e1-30de50dcbe96": "Windows Hello",
  "092277e5-8437-46b5-b911-ea64b294acb7": "Taglio CTAP2.1 CS",
  "09591fc6-9811-48f7-8f57-b9f23df6413f": "Pone Biometrics OFFPAD Authenticator",
  "09619fbf-d75e-4a62-be1d-fe4d240864ae": "VeriMark(TM) Guard 2.1 Fingerprint Security Key",
  "0a357157-9b18-4c8a-920e-d156e972b2f8": "YubiKey 5 Series (Consumer Profile)",
  "0acf3011-bc60-f375-fb53-6f05f43154e0": "Nymi FIDO2 Authenticator",
  "0b8b05a4-ebd4-4b0b-8f5f-33d7b6e606ab": "HID Crescendo 4000",
  "0bb43545-fd2c-4185-87dd-feb0b2916ace": "Security Key NFC by Yubico - Enterprise Edition",
  "0d9b2e56-566b-c393-2940-f821b7f15d6d": "Excelsecu eSecu FIDO2 Pro Security Key",
  "0db01cd6-5618-455b-bb46-1ec203d3213e": "GoldKey Security Token",
  "0ea242b4-43c4-4a1b-8b17-dd6d0b6baec6": "Keeper",
  "0ebd9f2c-f685-441c-8c3e-a02a234a840a": "YubiKey 5 Series with NFC Enhanced PIN (Consumer Profile)",
  "0f00cc22-4640-41e7-9585-384ec73ffe9b": "Taglio CTAP2.1 BIO",
  "0f083f18-4105-43a8-ad69-24e812e38141": "Security Key Series with NFC (Consumer Profile)",
  "10c70715-2a9a-4de1-b0aa-3cff6d496d39": "eToken Fusion NFC FIPS",
  "1105e4ed-af1d-02ff-ffff-ffffffffffff": "Egomet FIDO2 Authenticator for Android",
  "12755c32-8ad1-46eb-881c-e0b38d848b09": "Feitian ePass FIDO Authenticator (CTAP2.1, CTAP2.0, U2F)",
  "12ded745-4bed-47d4-abaa-e713f51d6393": "Feitian AllinOne FIDO2 Authenticator",
  "13ac47cf-1d78-4fd5-9060-aedaabacf826": "HID Crescendo Key V3 - Enterprise Edition",
  "146e77ef-11eb-4423-b847-ce77864e9411": "eToken Fusion NFC PIV",
  "149a2021-8ef6-4133-96b8-81f8d5b7f1f5": "Security Key by Yubico with NFC",
  "17290f1e-c212-34d0-1423-365d729f09d9": "Thales PIN iOS SDK",
  "175cd298-83d2-4a26-b637-313c07a6434e": "Chunghwa Telecom FIDO2 Smart Card Authenticator",
  "19083c3d-8383-4b18-bc03-8f1c9ab2fd1b": "YubiKey 5 Series",
  "1ac71f64-468d-4fe0-bef1-0e5f2f551f18": "YubiKey 5 Series with NFC (Enterprise Profile)",
  "1c086528-58d5-f211-823c-356786e36140": "Atos CardOS FIDO2",
  "1d1b4e33-76a1-47fb-97a0-14b10d0933f1": "Cryptnox FIDO2.1",
  "1d8cac46-47a1-3386-af50-e88ae46fe802": "Ledger Flex FIDO2 Authenticator",
  "1e906e14-77af-46bc-ae9f-fe6ef18257e4": "VeridiumID Passkey iOS SDK",
  "1f8e43df-71ff-e11d-bea3-c4ee7003b232": "Thetis Pro FIDO2 Key",
  "20ac7a17-c814-4833-93fe-539f0d5e3389": "YubiKey 5 Series (Enterprise Profile)",
  "20f0be98-9af9-986a-4b42-8eca4acb28e4": "Excelsecu eSecu FIDO2 Fingerprint Security Key",
  "2194b428-9397-4046-8f39-007a1605a482": "IDPrime 931 Fido",
  "22248c4c-7a12-46e2-9a41-44291b373a4d": "LogMeOnce",
  "22682ee5-4f0e-4c19-be3e-797d5770ebfe": "Precision InnaIT Key FIDO 2 Level 2 certified",
  "23195a52-62d9-40fa-8ee5-23b173f4fb52": "Hyper FIDO Pro NFC",
  "23315ad0-6aca-4ba1-952e-f044f1e36976": "Clife Key 2 NFC",
  "234cd403-35a2-4cc2-8015-77ea280c77f5": "Feitian ePass FIDO2-NFC Series (CTAP2.1, CTAP2.0, U2F)",
  "23786452-f02d-4344-87ed-aaf703726881": "SafeNet eToken Fusion CC",
  "24083bcb-3034-4867-99de-a3b52e1d426a": "Enterprise Security Key Series with NFC (Consumer Profile)",
  "24673149-6c86-42e7-98d9-433fb5b73296": "YubiKey 5 Series with Lightning",
  "2588ae83-5a3b-4536-b8de-5e540200d191": "Dapple Authenticator from Dapple Security Inc.",
  "260e3021-482d-442d-838c-7edfbe153b7e": "Feitian ePass FIDO2-NFC Plus Authenticator",
  "2772ce93-eb4b-4090-8b73-330f48477d73": "Security Key NFC by Yubico - Enterprise Edition Preview",
  "2a55aee6-27cb-42c0-bc6e-04efe999e88a": "HID Crescendo 4000",
  "2bff89f2-323a-48fc-b7c8-9ff7fe87c07e": "Feitian BioPass FIDO2 Pro (Enterprise Profile)",
  "2c0df832-92de-4be1-8412-88a8f074df4a": "Feitian FIDO Smart Card",
  "2c2aeed8-8174-4159-814b-486e92a261d0": "NEOWAVE WINKEO V2.0",
  "2cd2f727-f6ca-44da-8f48-5c2e5da000a2": "Nitrokey 3 AM",
  "2d3bec26-15ee-4f5d-88b2-53622490270b": "HID Crescendo Key V2",
  "2fc0579f-8113-47ea-b116-bb5a8db9202a": "YubiKey 5 Series with NFC",
  "2ffd6452-01da-471f-821b-ea4bf6c8676a": "IDPrime 941 Fido",
  "30b5035e-d297-4fc1-b00b-addc96ba6a97": "OneSpan FIDO Touch",
  "30b5035e-d297-4ff1-010b-addc96ba6a98": "OneSpan DIGIPASS FX1a",
  "30b5035e-d297-4ff1-020b-addc96ba6a98": "OneSpan DIGIPASS FX1-C",
  "30b5035e-d297-4ff1-b00b-addc96ba6a98": "OneSpan DIGIPASS FX1 BIO",
  "30b5035e-d297-4ff2-010b-addc96ba6a98": "OneSpan DIGIPASS FX2-A",
  "30b5035e-d297-4ff7-010b-addc96ba6a98": "OneSpan DIGIPASS FX7-B",
  "30b5035e-d297-4ff7-020b-addc96ba6a98": "OneSpan DIGIPASS FX7",
  "30b5035e-d297-4ff7-030b-addc96ba6a98": "OneSpan DIGIPASS FX7-C",
  "30b5035e-d297-4ff7-b00b-addc96ba6a98": "OneSpan DIGIPASS FX7",
  "3124e301-f14e-4e38-876d-fbeeb090e7bf": "YubiKey 5 Series with Lightning Preview",
  "31c3f7ff-bf15-4327-83ec-9336abcbcd34": "WinMagic FIDO Eazy - Software",
  "33d6d7d0-279f-4ef3-96b3-2d3282f4bde6": "Thales eToken Fusion BIO Enterprise",
  "341e4da9-3c2e-8103-5a9f-aad887135200": "Ledger Nano S FIDO2 Authenticator",
  "34744913-4f57-4e6e-a527-e9ec3c4b94e6": "YubiKey Bio Series - Multi-protocol Edition",
  "34f5766d-1536-4a24-9033-0e294e510fb0": "YubiKey 5 Series with NFC Preview",
  "357f2718-434f-4124-8a58-7e28c5e4a2fc": "Deepnet SafeKey/Classic (NFC)",
  "361a3082-0278-4583-a16f-72a527f973e4": "eWBM eFA500 FIDO2 Authenticator",
  "3789da91-f943-46bc-95c3-50ea2012f03a": "NEOWAVE Winkeo FIDO2",
  "39589099-9a75-49fc-afaa-801ca211c62a": "Feitian ePass FIDO-NFC (Enterprise Profile) (CTAP2.1, CTAP2.0, U2F)",
  "39a5647e-1853-446c-a1f6-a79bae9f5bc7": "IDmelon",
  "3a662962-c6d4-4023-bebb-98ae92e78e20": "YubiKey 5 FIPS Series with Lightning (Enterprise Profile)",
  "3aa78eb1-ddd8-46a8-a821-8f8ec57a7bd5": "YubiKey 5 CCN Series with NFC",
  "3b1adb99-0dfe-46fd-90b8-7f7614a4de2a": "GoTrust Idem Key",
  "3b24bf49-1d45-4484-a917-13175df0867b": "YubiKey 5 Series with Lightning (Enterprise Profile)",
  "3b3faa7b-2c56-4489-bcd3-53b83ee75768": "SECORA Connect SLS21 D1 FIDO 2.1 v1.0 by Infineon - Enterprise Edition",
  "3e078ffd-4c54-4586-8baa-a77da113aec5": "Hideez Key 3 FIDO2",
  "3e22415d-7fdf-4ea4-8a0c-dd60c4249b9d": "Feitian iePass FIDO Authenticator",
  "3e9db280-256a-4e17-b08e-19d79e9be166": "SECORA ID V2 by Infineon Pay Edition",
  "3ec9c8d3-a5a7-415b-a7b5-f1d606368d3f": "YubiKey 5 CCN Series with NFC (Enterprise Profile)",
  "3f59672f-20aa-4afe-b6f4-7e5e916b6d98": "Arculus FIDO 2.1 Key Card [P71]",
  "3fd410dc-8ab7-4b86-a1cb-c7174620b2dc": "IDEMIA SOLVO Fly 80 R1 FIDO Card Draft",
  "41e39911-c669-4811-b860-c6ad0b411b96": "YubiKey 5 Series with NFC (Enterprise Profile)",
  "42b4fb4a-2866-43b2-9bf7-6c6669c2e5d3": "Google Titan Security Key v2",
  "42df17de-06ba-4177-a2bb-6701be1380d6": "Feitian BioPass FIDO2 Plus Authenticator",
  "454e5346-4944-4ffd-6c93-8e9267193e9a": "Ensurity ThinC",
  "454e5346-4944-4ffd-6c93-8e9267193e9b": "Ensurity AUTH BioPro",
  "4599062e-6926-4fe7-9566-9e8fb1aedaa0": "YubiKey 5 Series (Enterprise Profile)",
  "46544d5d-8f5d-4db4-89ac-ea8977073fff": "Foongtone FIDO Authenticator",
  "47ab2fb4-66ac-4184-9ae1-86be814012d5": "Security Key NFC by Yubico - Enterprise Edition",
  "489ff376-b48d-6640-bb69-782a860ca795": "Mettlesemi Vishwaas Eagle Authenticator using FIDO2",
  "49a15c1c-3f63-3f51-23a7-b9e00096edd1": "IDEX CTAP2.1 Biometrics",
  "4b3f8944-d4f2-4d21-bb19-764a986ec160": "KeyXentic FIDO2 Secp256R1 FIDO2 CTAP2 Authenticator",
  "4b89f401-464e-4745-a520-486ddfc5d80e": "IIST FIDO2 Authenticator",
  "4c0cf95d-2f40-43b5-ba42-4c83a11c04ba": "Feitian BioPass FIDO2 Pro Authenticator",
  "4c50ff10-1057-4fc6-b8ed-43a529530c3c": "ImproveID Authenticator",
  "4d41190c-7beb-4a84-8018-adf265a6352d": "Thales IDPrime FIDO Bio",
  "4e2ddbc2-2687-4709-8551-cb66c9776bfe": "SECORA ID V2 FIDO2.1 L1",
  "4e768f2c-5fab-48b3-b300-220eb487752b": "Hideez Key 4 FIDO2 SDK",
  "4fc84f16-2545-4e53-b8fc-7bf4d7282a10": "YubiKey 5 CCN Series with NFC (Enterprise Profile)",
  "504d7149-4e4c-3841-4555-55445a677357": "WiSECURE AuthTron USB FIDO2 Authenticator",
  "50726f74-6f6e-5061-7373-50726f746f6e": "Proton Pass",
  "50a45b0c-80e7-f944-bf29-f552bfa2e048": "ACS FIDO Authenticator",
  "50cbf15a-238c-4457-8f16-812c43bf3c49": "Ensurity AUTH TouchPro",
  "516d3969-5a57-5651-5958-4e7a49434167": "SmartDisplayer BobeePass FIDO2 Authenticator",
  "522a3f91-5f5d-480d-be37-6cecfad5a27b": "Precision InnaIT Key FIDO 2 Level 2 certified",
  "524de2de-982f-49b4-a769-2b5e3b73ad79": "YubiKey 5 Series (Enterprise Profile)",
  "531126d6-e717-415c-9320-3d9aa6981239": "Dashlane",
  "53334693-4b3f-4198-8857-53772de2ab65": "Precision InnaIT Key FIDO 2 Level 2 certified",
  "53414d53-554e-4700-0000-000000000000": "Samsung Pass",
  "5343502d-5343-5343-6172-644649444f32": "ESS Smart Card Inc. Authenticator",
  "54d9fee8-e621-4291-8b18-7157b99c5bec": "HID Crescendo Enabled",
  "560a780c-b6ae-4f03-b110-082f856425b4": "KQC QuKey Bio FIDO2 Authenticator",
  "5626bed4-e756-430b-a7ff-ca78c8b12738": "VALMIDO PRO FIDO",
  "57235694-51a5-4a4d-a81a-f42185df6502": "SHALO AUTH",
  "5753362b-4e6b-6345-7b2f-255438404c75": "WiSECURE Blentity FIDO2 Authenticator",
  "57f7de54-c807-4eab-b1c6-1c9be7984e92": "YubiKey 5 FIPS Series",
  "58276709-bb4b-4bb3-baf1-60eea99282a7": "YubiKey Bio Series - Multi-protocol Edition 1VDJSN",
  "58b44d0b-0a7c-f33a-fd48-f7153c871352": "Ledger Nano S Plus FIDO2 Authenticator",
  "59f85fe7-faa5-4c92-9f52-697b9d4d5473": "RSA Authenticator 4 for Android",
  "5b0e46ba-db02-44ac-b979-ca9b84f5e335": "YubiKey 5 FIPS Series with Lightning Preview",
  "5ca1ab1e-1337-fa57-f1d0-a117e71ca702":
    "Allthenticator iOS App: roaming BLE FIDO2 Allthenticator for Windows, Mac, Linux, and Allthenticate door readers",
  "5ca1ab1e-fa57-1337-f1d0-a117371ca702":
    "Allthenticator Android App: roaming BLE FIDO2 Allthenticator for Windows, Mac, Linux, and Allthenticate door readers",
  "5d629218-d3a5-11ed-afa1-0242ac120002": "Swissbit iShield Key Pro",
  "5df66f62-5b47-43d3-aa1d-a6e31c8dbeb5": "Securitag Assembly Group FIDO Authenticator NFC",
  "5e264d9d-28ef-4d34-95b4-5941e7a4faa8": "Ideem ZSM FIDO2 Authenticator",
  "5ea308b2-7ac7-48b9-ac09-7e2da9015f8c": "Veridium Android SDK",
  "5eaff75a-dd43-451f-af9f-87c9eeae293e": "Swissbit iShield Key 2 FIPS Enterprise",
  "5fdb81b8-53f0-4967-a881-f5ec26fe4d18": "VinCSS FIDO2 Authenticator",
  "6002f033-3c07-ce3e-d0f7-0ffe5ed42543": "Excelsecu eSecu FIDO2 Fingerprint Key",
  "6028b017-b1d4-4c02-b4b3-afcdafc96bb2": "Windows Hello",
  "61250591-b2bc-4456-b719-0b17be90bb30": "eWBM eFPA FIDO2 Authenticator",
  "62e54e98-c209-4df3-b692-de71bb6a8528": "YubiKey 5 FIPS Series with NFC Preview",
  "662ef48a-95e2-4aaa-a6c1-5b9c40375824": "YubiKey 5 Series with NFC - Enhanced PIN",
  "664d9f67-84a2-412a-9ff7-b4f7d8ee6d05": "OpenSK authenticator",
  "66a0ccb3-bd6a-191f-ee06-e375c50b9846": "Thales Bio iOS SDK",
  "6832d205-75f2-44c7-a864-e868c796d06e": "Precision InnaIT Key FIDO 2 Level 2 certified",
  "686de81e-fff2-41c1-bb83-2723aaf3e913": "IIST SASE USB KEY 1",
  "692db549-7ae5-44d5-a1e5-dd20a493b723": "HID Crescendo Key",
  "69700f79-d1fb-472e-bd9b-a3a3b9a9eda0": "Pone Biometrics OFFPAD Authenticator",
  "6999180d-630c-442d-b8f7-424b90a43fae": "Hyper FIDO Pro (CTAP2.1, CTAP2.0, U2F)",
  "69e7c36f-f2f6-9e0d-07a6-bcc243262e6b": "OneKey FIDO2 Authenticator",
  "6ab56fad-881f-4a43-acb2-0be065924522": "YubiKey 5 Series with NFC (Enterprise Profile)",
  "6bb49926-160a-4306-a100-4eb39ba6ac45": "AVG Password Manager",
  "6d212b28-a2c1-4638-b375-5932070f62e9": "initial",
  "6d44ba9b-f6ec-2e49-b930-0c8fe920cb73": "Security Key by Yubico with NFC",
  "6d4aa745-dad5-40c4-b9b4-6a252fcee70f": "GoTrust Cyber Key",
  "6dae43be-af9c-417b-8b9f-1b611168ec60": "Dapple Authenticator from Dapple Security Inc.",
  "6e24d385-004a-16a0-7bfe-efd963845b34": "Ledger Stax FIDO2 Authenticator",
  "6e34341a-88c7-483d-b777-a425c355be93": "WebComm OETHenticator",
  "6e8d1eae-8d40-4c25-bcf8-4633959afc71": "Veridium iOS SDK",
  "6ec5cff2-a0f9-4169-945b-f33b563f7b99": "YubiKey Bio Series - Multi-protocol Edition (Enterprise Profile)",
  "70617373-7761-6c6c-6669-646f32303236": "Passwall",
  "70e7c36f-f2f6-9e0d-07a6-bcc243262e6b": "OneKey FIDO2 Bluetooth Authenticator",
  "72a2b5b1-95a5-4df9-a881-4192aff4f72e": "GoTrust Idem Key mini",
  "72c6b72d-8512-4c66-8359-9d3d10d9222f": "Security Key NFC by Yubico - Enterprise Edition (Enterprise Profile)",
  "73402251-f2a8-4f03-873e-3cb6db604b03": "uTrust FIDO2 Security Key",
  "73bb0cd4-e502-49b8-9c6f-b59445bf720b": "YubiKey 5 FIPS Series",
  "7409272d-1ff9-4e10-9fc9-ac0019c124fd": "YubiKey Bio Series - FIDO Edition",
  "74820b05-a6c9-40f9-8fb0-9f86aca93998": "SafeNet eToken Fusion",
  "760eda36-00aa-4d29-855b-4012a182cdeb": "Security Key NFC by Yubico Preview",
  "76692dc1-c56a-48d9-8e7d-31b5ced430ac": "VeriMark NFC+ USB-A Security Key",
  "77010bd7-212a-4fc9-b236-d2ca5e9d4084": "Feitian BioPass FIDO2 Authenticator",
  "771b48fd-d3d4-4f74-9232-fc157ab0507a": "Edge on Mac",
  "773c30d9-5919-4e96-a4f5-db65e95cf890": "GSTAG OAK FIDO2 Authenticator",
  "7787a482-13e8-4784-8a06-c7ed49a7aaf4": "Swissbit iShield Key 2",
  "78ba3993-d784-4f44-8d6e-cc0a8ad5230e": "Feitian ePass FIDO-NFC(CTAP2.1, CTAP2.0, U2F)",
  "7991798a-a7f3-487f-98c0-3faf7a458a04": "HID Crescendo Key V3",
  "79f3c8ba-9e35-484b-8f47-53a5a0f5c630": "YubiKey 5 FIPS Series with NFC (Enterprise Profile)",
  "7a53c643-9dec-4219-b3a4-f9d24aca4e12": "G+D StarKey FIDO2-NFC",
  "7b96457d-e3cd-432b-9ceb-c9fdd7ef7432": "YubiKey 5 FIPS Series with Lightning",
  "7d1351a6-e097-4852-b8bf-c9ac5c9ce4a3": "YubiKey Bio Series - Multi-protocol Edition",
  "7d2afadd-bf6b-44a2-a66b-e831fceb8eff": "Taglio CTAP2.1 EP",
  "7dab85a5-d16d-4eaf-a7ef-4c1385b151c5": "YubiKey 5 Series with NFC (Consumer Profile) KVZR57-2",
  "7e3f3d30-3557-4442-bdae-139312178b39": "RSA DS100",
  "817cdab8-0d51-4de1-a821-e25b88519cf3": "Swissbit iShield Key 2 FIPS",
  "820d89ed-d65a-409e-85cb-f73f0578f82a": "IDmelon Authenticator",
  "82b0a720-127a-4788-b56d-d1d4b2d82eac": "ID-One Key",
  "833b721a-ff5f-4d00-bb2e-bdda3ec01e29": "Feitian ePass FIDO2 Authenticator",
  "83c47309-aabb-4108-8470-8be838b573cb": "YubiKey Bio Series - FIDO Edition (Enterprise Profile)",
  "85203421-48f9-4355-9bc8-8a53846e5083": "YubiKey 5 FIPS Series with Lightning",
  "8681a073-5f50-4d52-bce4-e21658d207b3": "RSA Authenticator 4 for iOS",
  "87c13177-85d6-40ac-8c61-fe7ab3de9dfb": "HID Crescendo Key V3",
  "87dbc5a1-4c94-4dc8-8a47-97d800fd1f3c": "eWBM eFA320 FIDO2 Authenticator",
  "882adaf5-3aa9-4708-8e7d-3957103775b4": "T-Shield TrustSec FIDO2 Bio and client PIN version",
  "8836336a-f590-0921-301d-46427531eee6": "Thales Bio Android SDK",
  "8876631b-d4a0-427f-5773-0ec71c9e0279": "Solo Secp256R1 FIDO2 CTAP2 Authenticator",
  "88bbd2f0-342a-42e7-9729-dd158be5407a": "Precision InnaIT Key FIDO 2 Level 2 certified",
  "891494da-2c90-4d31-a9cd-4eab0aed1309": "Sésame",
  "8976631b-d4a0-427f-5773-0ec71c9e0279": "Solo Tap Secp256R1 FIDO2 CTAP2 Authenticator",
  "89b19028-256b-4025-8872-255358d950e4": "Sentry Enterprises CTAP2 Authenticator",
  "8c39ee86-7f9a-4a95-9ba3-f6b097e5c2ee": "YubiKey Bio Series - FIDO Edition (Enterprise Profile)",
  "8c97a730-3f7b-41a6-87d6-1e9b62bda6f0": "FT-JCOS FIDO Fingerprint Card",
  "8d1b1fcb-3c76-49a9-9129-5515b346aa02": "IDEMIA ID-ONE Card",
  "8d4378b0-725d-4432-b3c2-01fcdaf46286": "VeridiumID Passkey Android SDK",
  "8da0e4dc-164b-454e-972e-88f362b23d59": "CardOS FIDO2 Token",
  "8eec9bf9-486c-46da-9a67-1fbb4f66b9ed": "HID Crescendo 4000 FIPS",
  "9012593f-43e4-4461-a97a-d92777b55d74": "VinCSS FIDO2 Fingerprint",
  "905b4cb4-ed6f-4da9-92fc-45e0d4e9b5c7": "YubiKey 5 FIPS Series (Enterprise Profile)",
  "90636e1f-ef82-43bf-bdcf-5255f139d12f": "YubiKey Bio Series - Multi-protocol Edition",
  "912435d9-4a88-42f3-972d-1244b0d51420": "SI0X FIDO CL WRIST v1.0",
  "91ad6b93-264b-4987-8737-3a690cad6917": "Token Ring FIDO2 Authenticator",
  "930b0c03-ef46-4ac4-935c-538dccd1fcdb": "Chipwon Clife Key",
  "931327dd-c89b-406c-a81e-ed7058ef36c6": "Swissbit iShield Key FIDO2",
  "95442b2e-f15e-4def-b270-efb106facb4e": "eWBM eFA310 FIDO2 Authenticator",
  "95e4d58c-056e-4a65-866d-f5a69659e880": "TruU Windows Authenticator",
  "970c8d9c-19d2-46af-aa32-3f448db49e35": "WinMagic FIDO Eazy - TPM",
  "973446ca-e21c-9a9b-99f5-9b985a67af0f": "ACS FIDO Authenticator Card",
  "97e6a830-c952-4740-95fc-7c78dc97ce47": "YubiKey Bio Series - Multi-protocol Edition (Enterprise Profile)",
  "9806a2c8-c0da-478e-b4ca-620005d34182": "YubiKey Bio Multi-protocol Edition (Consumer Profile) 1VDJSN-2",
  "9876631b-d4a0-427f-5773-0ec71c9e0279": "Somu Secp256R1 FIDO2 CTAP2 Authenticator",
  "9955a1cd-564c-d388-ad68-9878a27be9f1": "StarSign Chase FIDO Card",
  "998f358b-2dd2-4cbe-a43a-e8107438dfb3": "OnlyKey Secp256R1 FIDO2 CTAP2 Authenticator",
  "99bf4610-ec26-4252-b31f-7380ccd59db5": "ZTPass SmartAuth",
  "99ed6c29-4573-4847-816d-78ad8f1c75ef": "VeroCard FIDO2 Authenticator",
  "9a272558-5cfa-4424-be37-65509677b77d": "SECORA ID Key S USB by Infineon Consumer Edition",
  "9a3f2abd-a73d-439c-9ee7-1b53a857eaa7": "YubiKey 5 Series with NFC Enhanced PIN (Enterprise Profile)",
  "9addb28c-b46f-4402-808f-019651441ff3": "KeePassPasskey",
  "9c835346-796b-4c27-8898-d6032f515cc5": "Cryptnox FIDO2",
  "9d3df6ba-282f-11ed-a261-0242ac120002": "Arculus FIDO2/U2F Key Card",
  "9dd8d593-2213-438a-97f8-d6b813d51c27": "YubiKey Bio Fido Edition (Consumer Profile)",
  "9ddd1817-af5a-4672-a2b9-3e3dd95000a9": "Windows Hello",
  "9e66c661-e428-452a-a8fb-51f7ed088acf": "YubiKey 5 FIPS Series with Lightning (RC Preview)",
  "9eb7eabc-9db5-49a1-b6c3-555a802093f4": "YubiKey 5 Series with NFC KVZR57",
  "9eb85bb6-9625-4a72-815d-0487830ccab2": "Ensurity AUTH BioPro Desktop",
  "9f0d8150-baa5-4c00-9299-ad62c8bb4e87": "GoTrust Idem Card",
  "9f77e279-a6e2-4d58-b700-31e5943c6a98": "Hyper FIDO Pro",
  "9ff4cc65-6154-4fff-ba09-9e2af7882ad2": "Security Key NFC by Yubico - Enterprise Edition (Enterprise Profile)",
  "a02140b7-0cbd-42e1-a9b5-a39da2545114": "Feitian BioPass FIDO2 Plus (Enterprise Profile)",
  "a02167b9-ae71-4ac7-9a07-06432ebb6f1c": "YubiKey 5 Series with Lightning",
  "a10c6dd9-465e-4226-8198-c7c44b91c555": "Kaspersky Password Manager",
  "a11a5faa-9f32-4b8c-8c5d-2f7d13e8c942": "AliasVault",
  "a1f52be5-dfab-4364-b51c-2bd496b14a56": "OCTATCO EzFinger2 FIDO2 AUTHENTICATOR",
  "a25342c0-3cdc-4414-8e46-f4807fca511c": "YubiKey 5 Series with NFC",
  "a3975549-b191-fd67-b8fb-017e2917fdb3": "Excelsecu eSecu FIDO2 NFC Security Key",
  "a4a2d88e-9796-4356-9164-e2a5a8bd019c": "Avast Password Manager",
  "a4e9fc6d-4cbe-4758-b8ba-37598bb5bbaa": "Security Key NFC by Yubico",
  "a6c5f5d8-2ad0-48b6-8257-e502c8970931": "eToken FIDO NFC Enterprise",
  "a7fc3f84-86a3-4da4-a3d7-eb6485a066d8": "NEOWAVE Badgeo FIDO2 (CTAP 2.1)",
  "aa79f476-ea00-417e-9628-1e8365123922": "HID Crescendo 4000 FIDO",
  "ab32f0c6-2239-afbb-c470-d2ef4e254db6": "TEST (DUMMY RECORD)",
  "ab32f0c6-2239-afbb-c470-d2ef4e254db7": "TOKEN2 FIDO2 Security Key",
  "ab7d1767-3fa0-4388-b6c4-feef7a844809": "Enterprise Security Key Series with NFC (Enterprise Profile)",
  "ad08c78a-4e41-49b9-86a2-ac15b06899e2": "YubiKey Bio Series - FIDO Edition (Enterprise Profile)",
  "adce0002-35bc-c60a-648b-0b25f1f05503": "Chrome on Mac",
  "add92433-0d69-4026-8166-29b25bce64e9": "YubiKey Bio Fido Edition (Enterprise Profile)",
  "aeb6569c-f8fb-4950-ac60-24ca2bbe2e52": "HID Crescendo C2300",
  "b113a455-cfb6-4c17-8cba-cd952feb7d48": "eToken FIDO NFC",
  "b12eac35-586c-4809-a4b1-d81af6c305cf": "Deepnet SafeKey/Classic (NFC)",
  "b267239b-954f-4041-a01b-ee4f33c145b6": "authenton1 - CTAP2.1",
  "b2c1a50b-dad8-4dc7-ba4d-0ce9597904bc": "YubiKey 5 Series with NFC - Enhanced PIN (Enterprise Profile)",
  "b3315166-f36c-b05f-fea8-66a3dfdad171": "Ledger Nano Gen5 FIDO2 Authenticator",
  "b35a26b2-8f6e-4697-ab1d-d44db4da28c6": "Zoho Vault",
  "b415094c-49d3-4c8b-b3fe-7d0ad28a6bc4": "ZTPass SmartAuth",
  "b50d5e0a-7f81-4959-9b12-f45407407503": "IDPrime 3940 FIDO",
  "b5397666-4885-aa6b-cebf-e52262a439a2": "Chromium Browser",
  "b6ede29c-3772-412c-8a78-539c1f4c62d2": "Feitian BioPass FIDO2 Plus Authenticator",
  "b78a0a55-6ef8-d246-a042-ba0f6d55050c": "LastPass",
  "b7d3f68e-88a6-471e-9ecf-2df26d041ede": "Security Key NFC by Yubico",
  "b84e4048-15dc-4dd0-8640-f4f60813c8af": "NordPass",
  "b90e7dc1-316e-4fee-a25a-56a666a670fe": "YubiKey 5 Series with Lightning (Enterprise Profile)",
  "b92c3f9a-c014-4056-887f-140a2501163b": "Security Key by Yubico",
  "b93fd961-f2e6-462f-b122-82002247de78": "Android Authenticator",
  "b9f6b7b6-f929-4189-bca9-dd951240c132": "Deepnet SafeKey/Classic (USB)",
  "ba0a9266-40d8-4048-9786-d710b5474752": "YubiKey Bio Multi-protocol Edition (Consumer Profile)",
  "ba76a271-6eb6-4171-874d-b6428dbe3437": "ATKey.ProS",
  "ba86dc56-635f-4141-aef6-00227b1b9af6": "TruU Windows Authenticator",
  "bada5566-a7aa-401f-bd96-45619a55120d": "1Password",
  "bb405265-40cf-4115-93e5-a332c1968d8c": "ID-One Card",
  "bb66c294-de08-47e4-b7aa-d12c2cd3fb20": "Mettlesemi Vishwaas Hawk Authenticator using FIDO2",
  "bb878d7b-cf54-4784-b390-357030497043": "TruU FIDO2 Authenticator",
  "bbf4b6a7-679d-f6fc-c4f2-8ac0ddf9015a": "Excelsecu eSecu FIDO2 PRO Security Key",
  "bc2fe499-0d8e-4ffe-96f3-94a82840cf8c": "OCTATCO EzQuant FIDO2 AUTHENTICATOR",
  "be727034-574a-f799-5c76-0929e0430973": "Crayonic KeyVault K1 (USB-NFC-BLE FIDO2 Authenticator)",
  "bfc748bb-3429-4faa-b9f9-7cfa9f3b76d0": "iPasswords",
  "c1288a5c-d66b-495c-a68f-4e81f9ec5b53": "Deepnet SafeKey/Classic (FP) XF",
  "c1f9a0bc-1dd2-404a-b27f-8e29047a43fd": "YubiKey 5 FIPS Series with NFC",
  "c3479970-e58a-4f70-836f-853bf42fb063": "YubiKey 5 Series with Lightning (Enterprise Profile)",
  "c3f47802-de73-4dfc-ba22-671fe3304f90": "eToken Fusion NFC PIV Enterprise",
  "c4ddaf11-3032-4e77-b3b9-3a340369b9ad": "HID Crescendo Fusion",
  "c5703116-972b-4851-a3e7-ae1259843399": "NEOWAVE Badgeo FIDO2",
  "c5ef55ff-ad9a-4b9f-b580-adebafe026d0": "YubiKey 5 Series with Lightning",
  "c611b55c-77b2-4527-8082-590e931b2f08": "GoTrust Idem Key ",
  "c62100de-759b-4bf8-b22b-63b3e3a80401": "Token Ring 3 FIDO2 Authenticator",
  "c80dbd9a-533f-4a17-b941-1a2f1c7cedff": "HID Crescendo C3000",
  "c89674e3-a765-4b07-888a-7c086fbdf04b": "StarSign FIDO Card",
  "c89e6a38-6c00-5426-5aa5-c9cbf48f0382": "ACS FIDO Authenticator NFC",
  "c9cadfc9-89a9-489e-a25a-c7e86a4d5f15": "Burp Suite Navigation Recorder",
  "ca4cff1b-5a81-4404-8194-59aabcf1660b": "IDPrime 3930 FIDO",
  "ca87cb70-4c1b-4579-a8e8-4efdd7c007e0": "FIDO Alliance TruU Sample FIDO2 Authenticator",
  "cb4f796c-a20a-af9e-d639-213c1ec247f3": "ACS PocketKey+ Bio",
  "cb69481e-8ff7-4039-93ec-0a2729a154a8": "YubiKey 5 Series",
  "cc45f64e-52a2-451b-831a-4edd8022a202": "ToothPic Passkey Provider",
  "cd69adb5-3c7a-deb9-3177-6800ea6cb72a": "Thales PIN Android SDK",
  "cdbdaea2-c415-5073-50f7-c04e968640b6": "Excelsecu eSecu FIDO2 Security Key",
  "ce6bf97f-9f69-4ba7-9032-97adc6ca5cf1": "YubiKey 5 FIPS Series with NFC (RC Preview)",
  "cfcb13a2-244f-4b36-9077-82b79d6a7de7": "USB/NFC Passcode Authenticator",
  "d2fbd093-ee62-488d-9dad-1e36389f8826": "YubiKey 5 FIPS Series (RC Preview)",
  "d3452668-01fd-4c12-926c-83a4204853aa": "Microsoft Password Manager",
  "d350af52-0351-4ba2-acd3-dfeeadc3f764": "pwSafe",
  "d384db22-4d50-ebde-2eac-5765cf1e2a44": "Excelsecu eSecu FIDO2 Fingerprint Security Key",
  "d41f5a69-b817-4144-a13c-9ebd6d9254d6": "ATKey.Card CTAP2.0",
  "d49b2120-b865-4191-8cea-be84a52b0485": "Heimlane Vault",
  "d548826e-79b4-db40-a3d8-11116f7e8349": "Bitwarden",
  "d61d3b87-3e7c-4aea-9c50-441c371903ad": "KeyVault Secp256R1 FIDO2 CTAP2 Authenticator",
  "d716019a-9f4e-4041-9750-17c78f8ae81a": "eToken Fusion BIO",
  "d7781e5d-e353-46aa-afe2-3ca49f13332a": "YubiKey 5 Series with NFC",
  "d7a423ad-3e19-4492-9200-78137dccc136": "VivoKey Apex FIDO2",
  "d821a7d4-e97c-4cb6-bd82-4237731fd4be": "Hyper FIDO Bio Security Key",
  "d8522d9f-575b-4866-88a9-ba99fa02f35b": "YubiKey Bio Series - FIDO Edition",
  "d91c5288-0ef0-49b7-b8ae-21ca0aa6b3f3": "KEY-ID FIDO2 Authenticator",
  "d94a29d9-52dd-4247-9c2d-8b818b610389": "VeriMark Guard Fingerprint Key",
  "d9be9d39-e6a6-4c28-a581-32b044d986e4": "Sticky Password Manager",
  "da1fa263-8b25-42b6-a820-c0036f21ba7f": "ATKey.Card NFC",
  "dc5e949d-f939-43b3-9877-a85c7186b753": "YubiKey Bio Multi-protocol Edition (Enterprise Profile)",
  "dd4ec289-e01d-41c9-bb89-70fa845d4bf2": "iCloud Keychain (Managed)",
  "dd86a2da-86a0-4cbe-b462-4bd31f57bc6f": "YubiKey Bio Series - FIDO Edition",
  "dda9aa35-aaf1-4d3c-b6db-7902fd7dbbbf": "IDEMIA SOLVO Fly 80 R3 FIDO Card c",
  "de503f9c-21a4-4f76-b4b7-558eb55c6f89": "Devolutions",
  "dee49ee1-11cb-47b6-bed0-8e995e67a0fb": "SECORA Connect SLS21 D1 FIDO 2.1 v1.0 by Infineon - Consumer Edition",
  "def8ab1a-9f91-44f1-a103-088d8dc7d681": "IDEMIA SOLVO Fly 80 R3 FIDO Card e",
  "e1a96183-5016-4f24-b55b-e3ae23614cc6": "ATKey.Pro CTAP2.0",
  "e400ef8c-711d-4692-af46-7f2cf7da23ad": "Swissbit iShield Key 2 Enterprise",
  "e416201b-afeb-41ca-a03d-2281c28322aa": "ATKey.Pro CTAP2.1",
  "e41b42a3-60ac-4afb-8757-a98f2d7f6c9f": "Deepnet SafeKey/Classic (FP)",
  "e77e3c64-05e3-428b-8824-0cbeb04b829d": "Security Key NFC by Yubico",
  "e7db2bd3-f2fe-4d71-ad78-7e7aa166cfd1": "Avira Password Manager",
  "e86addcd-7711-47e5-b42a-c18257b0bf61": "IDCore 3121 Fido",
  "e8b7f4a2-c3d5-e6f7-890a-b1c2d3e4f567": "Sherlocked",
  "ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4": "Google Password Manager",
  "eabb46cc-e241-80bf-ae9e-96fa6d2975cf": "TOKEN2 PIN Plus Security Key Series ",
  "eaecdef2-1c31-5634-8639-f1cbd9c00a08": "KeePassDX",
  "eb3b131e-59dc-536a-d176-cb7306da10f5": "ellipticSecure MIRkey USB Authenticator",
  "eb7ef748-cbe0-4b40-b8f6-07bd2d592d35": "YubiKey 5 CCN Series with NFC (Consumer Profile)",
  "ec31b4cc-2acc-4b8e-9c01-bade00ccbe26": "KeyXentic FIDO2 Secp256R1 FIDO2 CTAP2 Authenticator",
  "ed042a3a-4b22-4455-bb69-a267b652ae7e": "Security Key NFC by Yubico - Enterprise Edition",
  "ee041bce-25e5-4cdb-8f86-897fd6418464": "Feitian ePass FIDO2-NFC Authenticator",
  "ee7fa1e0-9539-432f-bd43-9c2fc6d4f311": "VeriMark NFC+ USB-C Security Key",
  "ee882879-721c-4913-9775-3dfcce97072a": "YubiKey 5 Series",
  "efb96b10-a9ee-4b6c-a4a9-d32125ccd4a4": "Safenet eToken FIDO",
  "f2145e86-211e-4931-b874-e22bba7d01cc": "ID-One Key",
  "f3809540-7f14-49c1-a8b3-8f813b225541": "Enpass",
  "f4c63eff-d26c-4248-801c-3736c7eaa93a": "FIDO KeyPass S3",
  "f4ce5fc0-57d3-46f5-a736-efb7d5bc63b5": "YubiKey 5 Series with NFC (Consumer Profile)",
  "f56f58b3-d711-4afc-ba7d-6ac05f88cb19": "WinMagic FIDO Eazy - Phone",
  "f573f209-b7fb-b261-671a-d7cf624cc812": "Excelsecu eSecu FIDO2 PRO+ Security Key",
  "f7c558a0-f465-11e8-b568-0800200c9a66": "KONAI Secp256R1 FIDO2 Conformance Testing CTAP2 Authenticator",
  "f8a011f3-8c0a-4d15-8006-17111f9edc7d": "Security Key by Yubico",
  "f8d5c4e9-e539-4c06-8662-ec2a4155a555": "StarSign Key Fob",
  "fa2b99dc-9e39-4257-8f92-4a30d23c4118": "YubiKey 5 Series with NFC",
  "fa37f553-f9b6-4adb-ac53-8bbb57ebdf0d": "Norton Password Manager",
  "fbefdf68-fe86-0106-213e-4d5fa24cbe2e": "Excelsecu eSecu FIDO2 NFC Security Key",
  "fbfc3007-154e-4ecc-8c0b-6e020557d7bd": "Apple Passwords",
  "fc5ca237-69a0-4f3c-afe4-1ebc66def6df": "Clife Key 2",
  "fcb1bcb4-f370-078c-6993-bc24d0ae3fbe": "Ledger Nano X FIDO2 Authenticator",
  "fcc0118f-cd45-435b-8da1-9782b2da0715": "YubiKey 5 FIPS Series with NFC",
  "fdb141b2-5d84-443e-8a35-4698c205a502": "KeePassXC",
  "fec067a1-f1d0-4c5e-b4c0-cc3237475461": "KX701 SmartToken FIDO",
  "ff4dac45-ede8-4ec2-aced-cf66103f4335": "YubiKey 5 Series",
};
